// Custom Level ONLY: the same S3 object bytes often exist under several
// Activity-local paths (gamedata and immersion_*, sometimes many activities).
// Preserve every logical key, but transfer the exact identical bytes once.
// This helper is pure; Placement never calls it.
export function buildCustomLevelDirectReusePlan(entries = []) {
  const jobs = [];
  const byFingerprint = new Map();

  (Array.isArray(entries) ? entries : []).forEach((entry) => {
    const source = String(entry?.source || '');
    const key = String(entry?.key || '');
    const etag = String(entry?.etag || '').replace(/^"|"$/g, '').toLowerCase();
    const size = Number(entry?.size || 0);
    // Only use plain single-part content hashes in the uploads Activity scope.
    // Multipart/SSE/nonstandard ETags and unrelated assets are never coalesced.
    const eligible = source === 'uploads'
      && key.startsWith('public/Activities/')
      && Number.isSafeInteger(size)
      && size > 0
      && /^[a-f0-9]{32}$/.test(etag);
    const fingerprint = eligible ? `${source}:${etag}:${size}` : '';
    const existing = fingerprint ? byFingerprint.get(fingerprint) : null;
    if (existing) {
      existing.aliases.push(entry);
    } else {
      const job = { entry, aliases: [] };
      jobs.push(job);
      if (fingerprint) byFingerprint.set(fingerprint, job);
    }
  });
  return jobs;
}
